<template>
  <asc-dialog
    :show-dialog="showDialog"
    text="Export Fault Monitors"
    :on-close="onCloseDialog"
    :on-primary="handleAccept"
    :primary-available="isCurrentDataValid"
    primary-button-text="Submit"
    full-width-buttons
    :width="500"
  >
    <template v-if="showDialog">
      <asc-fault-monitor-export
        v-model="currentData"
        :airlines="airlines"
      ></asc-fault-monitor-export>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscFaultMonitorExport from './AscFaultMonitorExport'

export default {
  name: 'AscFaultMonitorExportDialog',

  components: {
    AscDialog,
    AscFaultMonitorExport,
  },

  mixins: [AscDialogMixin],

  props: {
    reportTypes: {
      type: Array,
      default: () => [],
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    tails: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentData: null,
    }
  },

  computed: {
    isCurrentDataValid() {
      if (!this.currentData) {
        return false
      }
      if (this.currentData) {
        if (!this.currentData.dates) {
          return false
        }
        if (
          !this.currentData.dates.endDate ||
          !this.currentData.dates.startDate
        ) {
          return false
        }
      }
      if (this.currentData.airlineIds.length === 0) {
        return false
      }
      return true
    },
  },

  methods: {
    handleAccept() {
      this.onAccept(this.currentData)
      this.handleClose()
      this.currentData = null
    },
    onCloseDialog() {
      this.handleClose()
      this.currentData = null
    },
  },
}
</script>
